// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

//---- jQuery(UI) ----
import './src/jquery'
import 'jquery-ui/dist/jquery-ui'

//---- JavintoAppPages
require("./packs/content/content_assets")
require("./packs/content/content_pages")
require("./packs/tasks")

require("./packs/global");
require("./packs/global_bootstrap");

//---- FancyBox, see application.scss for CSS
import { Fancybox } from "@fancyapps/ui/dist/index.js";
document.addEventListener("turbo:load", () => {
  Fancybox.bind("[data-fancybox]", {
    // Zet de Hash plugin uit. Dit zorgt voor een refresh probleem als je de Fancybox popup sluit.
    closeExisting: true,
    Hash: false
  });  
});
document.addEventListener('turbo:before-cache', () => {
  Fancybox.destroy();
});

//---- molendatabase.nl ----
require("./packs/sort");
require("./packs/modals");
require("./packs/stream_actions");
require("./packs/timeout");
require("./pagination");

/**
/* Skip ActionText in favour of TinyMCE, but keep it installed 
/* import "trix"
/* import "@rails/actiontext"
**/


/* ActionText changes. Gebruik <p> ipv <div> en <h2> ipv <h1>*/
// Trix.config.blockAttributes.default= {
//     tagName: "p",
//     parse: false
// }

// Trix.config.blockAttributes.heading1 = {
//     tagName: "h2",
//     terminal: true,
//     breakOnReturn: true,
//     group: false
// }